import { createAuthClient } from 'better-auth/react'
import { magicLinkClient, twoFactorClient, jwtClient, inferAdditionalFields } from 'better-auth/client/plugins'
import { passkeyClient } from '@better-auth/passkey/client'
import { dashClient, sentinelClient } from '@better-auth/infra/client'

/** Same-origin Better Auth (Vite proxies /api/auth → auth-service locally). */
export const authClient = createAuthClient({
  basePath: '/api/auth',
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [
    magicLinkClient(),
    passkeyClient(),
    twoFactorClient({
      onTwoFactorRedirect() {
        // LoginPage reads session / query; no hard navigation needed for SPA.
      },
    }),
    jwtClient(),
    dashClient(),
    sentinelClient({ autoSolveChallenge: true }),
    inferAdditionalFields({
      user: {
        twoFactorEnabled: { type: 'boolean' },
      },
    }),
  ],
})

export type SessionUser = NonNullable<
  Awaited<ReturnType<typeof authClient.getSession>>['data']
>['user']

/** SPA-facing identity (Firebase User shape compatibility). */
export type OperatorUser = {
  uid: string
  email: string | null
  emailVerified: boolean
  displayName: string | null
  twoFactorEnabled: boolean
}

export function toOperatorUser(user: SessionUser): OperatorUser {
  return {
    uid: user.id,
    email: user.email ?? null,
    emailVerified: Boolean(user.emailVerified),
    displayName: user.name ?? null,
    twoFactorEnabled: Boolean(
      (user as SessionUser & { twoFactorEnabled?: boolean }).twoFactorEnabled,
    ),
  }
}
